module.exports = __webpack_public_path__ + "img/bg.3f9a7aec.png";